import { useCallback, useMemo } from 'react';
import { __AUTHORIZATIONS__ } from 'shell/constants/environment';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { CollapseItemProps } from './collapse-item';
import { Feature } from 'shell/models/feature';

/**
 * The hook to check if to filter the user menu items
 * @param {CollapseItemProps[]} items the items to check
 * @returns {CollapseItemProps[]} is authorized for this items
 */
export const useMenuItemsAuthorization = (items: CollapseItemProps[]): CollapseItemProps[] => {
  const { userProfile } = useUserProfile();

  const authorizationItems = useMemo(
    () => userProfile.datiLogin?.profile?.authorizationItems?.slice() || [],
    [userProfile.datiLogin?.profile?.authorizationItems]
  );

  const filterAuthItems = useCallback(
    (inputItems: CollapseItemProps[]): CollapseItemProps[] =>
      inputItems
        .map((item: CollapseItemProps) => {
          if (item.authorizations) {
            const found = item.authorizations?.find((authorization) =>
              authorizationItems.find((auth) => authorization === auth)
            );

            if (!found) {
              return;
            }
          }

          if (item.abilitations) {
            const foundAbilitation = Object.keys(item.abilitations || {})?.find(
              (keyAbilitation) => {
                const featureUser = userProfile.datiLogin?.profile?.feature || {};
                const key = keyAbilitation as keyof Feature;
                const featureValueUser = featureUser[key];
                const featureMenuAbilitations = item.abilitations || {};
                const featureValue = featureMenuAbilitations[key];

                if (featureValue?.includes(featureValueUser as string)) {
                  return true;
                }
                return false;
              }
            );

            if (!foundAbilitation) {
              return;
            }
          }

          return item;
        })
        .filter((definedItem) => definedItem) as CollapseItemProps[],
    [authorizationItems, userProfile.datiLogin?.profile?.feature]
  );

  const authItems = useMemo(() => filterAuthItems((items || []).slice()), [items, filterAuthItems]);

  return __AUTHORIZATIONS__ ? authItems : items;
};
